<template>
  <div class="am_index asset_detail_page">
    <div class="back_div">
      <div class="back_div_left asset_info_dropdown">
        <Button icon="ios-arrow-back" @click="btnHandle"></Button>
        <span style="margin-left: 16px">Asset Detail</span>
      </div>
    </div>
    <Row :gutter="16">
      <Col :span="6">
        <Card style="min-height: 723px">
          <div slot="title">
            {{ deviceDetailsObj.name }}
            <span class="drawer_status" :class="deviceDetailsObj.status">{{
              deviceDetailsObj.status
            }}</span>
          </div>
          <DeviceDetails :deviceDetailsObj="deviceDetailsObj"></DeviceDetails>
        </Card>
      </Col>
      <Col :span="18">
        <Tabs type="card">
          <TabPane label="Insight">
            <div class="detail_card_image">
              <div class="detail_card_auto">
                <img
                  v-for="(item, index) in 6"
                  :key="index"
                  :src="'/static/image/card' + item + '.png'"
                />
              </div>
            </div>
            <Row :gutter="16">
              <Col :span="12">
                <div class="asset_detail_chart">
                  <div id="Insight_echarts"></div>
                </div>
              </Col>
              <Col :span="12">
                <div class="asset_detail_chart">
                  <div id="Insight_echarts2"></div>
                </div>
              </Col>
            </Row>
          </TabPane>
          <TabPane label="Works Order">
            <Row :gutter="16">
              <Col :span="14">
                <div class="asset_detail_img">
                  <img src="../../public/image/Main_image.png" />
                </div>
              </Col>
              <Col :span="10"
                ><div class="asset_detail_img">
                  <img src="../../public/image/WorkOrder_image.png" /></div
              ></Col>
            </Row>
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  </div>
</template>
<script>
import apiRoutes from "@/config/API_ROUTER";
import * as echarts from "echarts";
import DeviceDetails from "../components/DeviceDetails";

export default {
  data() {
    return {
      deviceDetailsObj: {},
      InsightEcharts: null,
      InsightEcharts2: null,
    };
  },
  methods: {
    init() {
      this.getDetailFun();
    },
    btnHandle() {
      this.$router.push({
        path: "/",
        query: this.$route.query,
      });
    },
    getDetailFun() {
      const url = apiRoutes.Asset;
      const id = this.$route.query.assetId;
      this.$http.get(`${url}/${id}`).then((res) => {
        // console.log(res);
        if (res.data.message === "Succeed") {
          this.deviceDetailsObj = JSON.parse(JSON.stringify(res.data.data));

          this.InsightEcharts = echarts.init(
            document.getElementById("Insight_echarts")
          );
          this.InsightEchartsFun();
          this.InsightEcharts2 = echarts.init(
            document.getElementById("Insight_echarts2")
          );
          this.InsightEchartsFun2();
        }
      });
    },
    InsightEchartsFun() {
      const { name } = this.deviceDetailsObj;
      this.InsightEcharts.setOption({
        title: {
          text: name || "AHU_03_01",
          left: "center",
          top: "20px",
        },
        backgroundColor: "#FFF",
        color: ["rgb(160,167,250)", "rgb(107,230,193)", "rgb(63,177,227)"],
        grid: {
          right: 180,
          top: 80,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["RAT", "CO2", "Energy"],
          bottom: "10px",
          icon: "rect",
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar"] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            // prettier-ignore
            data: ['00:00', '03:00', '06:00', '09:00', '12:00', '15:00', '18:00', '21:00', '24:00', '03:00'],
          },
        ],
        yAxis: [
          {
            type: "value",
            position: "left",
            min: 20,
            name: "Rat (°C)",
            nameLocation: "middle",
            axisLine: {
              lineStyle: {
                color: "rgb(160,167,250)",
                width: 1,
              },
            },
          },
          {
            type: "value",
            position: "right",
            offset: 80,
            min: 200,
            name: "CO2 (ppm)",
            nameGap: 50,
            nameLocation: "middle",
            axisLine: {
              lineStyle: {
                color: "rgb(107,230,193)",
                width: 1,
              },
            },
          },
          {
            type: "value",
            position: "right",
            min: 45700,
            name: "Energy (kWh)",
            nameGap: 60,
            nameLocation: "middle",
            axisLine: {
              lineStyle: {
                color: "rgb(63,177,227)",
                width: 1,
              },
            },
          },
        ],
        series: [
          {
            name: "RAT",
            type: "line",
            yAxisIndex: 0,
            data: [24, 25, 26, 28, 29, 28.4, 25, 23, 22.3, 22.0],
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
            // markLine: {
            //   data: [{ type: "average", name: "Avg" }]
            // }
          },
          {
            name: "CO2",
            type: "line",
            yAxisIndex: 1,
            data: [511, 524, 530, 526, 531, 514, 499, 512, 532, 528],
            markPoint: {
              data: [
                { name: "Max", value: 182.2, xAxis: 7, yAxis: 183 },
                { name: "Min", value: 2.3, xAxis: 11, yAxis: 3 },
              ],
            },
          },
          {
            name: "Energy",
            type: "line",
            yAxisIndex: 2,
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
            data: [
              45793.5, 45803.8, 45822.5, 45834.2, 45839.5, 45840.5, 45958.5,
              45967.5, 45997.8, 45999.5,
            ],
          },
        ],
      });
    },
    InsightEchartsFun2() {
      this.InsightEcharts2.setOption({
        title: {
          text: "Daily Consumption",
          left: "center",
          top: "20px",
        },
        backgroundColor: "#FFF",
        color: ["rgb(160,167,250)", "rgb(107,230,193)", "rgb(63,177,227)"],
        grid: {
          right: 180,
          top: 80,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["RAT", "CO2", "Energy"],
          bottom: "10px",
          icon: "rect",
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar"] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            // prettier-ignore
            data: ['Jun 1', 'Jun 2', 'Jun 3', 'Jun 4', 'Jun 5', 'Jun 6', 'Jun 7', 'Jun 8', 'Jun 9', 'Jun 10'],
          },
        ],
        yAxis: [
          {
            type: "value",
            position: "left",
            min: 500,
            name: "Rat (°C)",
            nameLocation: "middle",
            axisLine: {
              lineStyle: {
                color: "rgb(160,167,250)",
                width: 1,
              },
            },
          },
          {
            type: "value",
            position: "right",
            offset: 80,
            min: 2000,
            name: "CO2 (ppm)",
            nameGap: 50,
            nameLocation: "middle",
            axisLine: {
              lineStyle: {
                color: "rgb(107,230,193)",
                width: 1,
              },
            },
          },
          {
            type: "value",
            position: "right",
            min: 35700,
            name: "Energy (MWh)",
            nameGap: 60,
            nameLocation: "middle",
            axisLine: {
              lineStyle: {
                color: "rgb(63,177,227)",
                width: 1,
              },
            },
          },
        ],
        series: [
          {
            name: "RAT",
            type: "bar",
            yAxisIndex: 0,
            data: [550, 570, 560, 534, 527, 593, 547, 603, 537, 557, 521],
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
            // markLine: {
            //   data: [{ type: "average", name: "Avg" }]
            // }
          },
          {
            name: "CO2",
            type: "bar",
            yAxisIndex: 1,
            data: [2511, 2124, 2230, 2226, 2531, 2514, 2299, 2312, 2392, 2428],
            markPoint: {
              data: [
                { name: "Max", value: 182.2, xAxis: 7, yAxis: 183 },
                { name: "Min", value: 2.3, xAxis: 11, yAxis: 3 },
              ],
            },
          },
          {
            name: "Energy",
            type: "bar",
            yAxisIndex: 2,
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
            data: [
              35793.5, 35803.8, 35822.5, 35834.2, 35839.5, 35840.5, 35958.5,
              35967.5, 35997.8, 35999.5,
            ],
          },
        ],
      });
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  components: {
    DeviceDetails,
  },
};
</script>
<style lang="less">
.asset_detail_page {
  padding: 16px;
  .back_div {
    margin-bottom: 16px;
  }
  .device_details {
    padding: 0;
  }
}
.detail_card_image {
  width: 100%;
  overflow: auto;
  margin-bottom: 16px;
  .detail_card_auto {
    white-space: nowrap;
    font-size: 0;
  }
}
.asset_detail_chart {
  height: 500px;
  > div {
    height: 100%;
  }
}
.asset_detail_img {
  img {
    display: block;
    width: 100%;
  }
}
.drawer_status {
  color: #4a4a4a;
  font-size: 12px;
  margin-left: 20px;
  position: relative;
  &::before {
    position: absolute;
    left: -10px;
    top: 6px;
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #4a4a4a;
  }
  &.Normal {
    color: #00a870;
    &::before {
      background: #00a870;
    }
  }
  &.Fault {
    color: #ed7b2f;
    &::before {
      background: #ed7b2f;
    }
  }
}
</style>
